// Increment 45a: native (Capacitor) startup glue — status bar, splash screen,
// deep links, and priming the secure token cache. All no-ops on the web build.
import { isNativeApp, primeNativeToken } from "./platform";

const PROD_HOSTS = ["v3.uat.kontrataph.com", "kontrataph.com"];

/** Initialize native integrations. Safe to await on web (returns immediately). */
export async function initNative(): Promise<void> {
  if (!isNativeApp()) return;

  // Make the secure-stored auth token available to the synchronous API client.
  await primeNativeToken();

  // Status bar + splash.
  try {
    const { StatusBar, Style } = await import("@capacitor/status-bar");
    await StatusBar.setStyle({ style: Style.Dark });
  } catch { /* plugin optional */ }
  try {
    const { SplashScreen } = await import("@capacitor/splash-screen");
    await SplashScreen.hide();
  } catch { /* plugin optional */ }

  // Deep links: when a shared https link to our host opens the app, route to the
  // in-app path so /s/:id, /j/:id, etc. resolve natively instead of the browser.
  try {
    const { App } = await import("@capacitor/app");
    App.addListener("appUrlOpen", (event: { url: string }) => {
      try {
        const u = new URL(event.url);
        if (PROD_HOSTS.includes(u.hostname)) {
          const target = u.pathname + u.search + u.hash;
          if (target && target !== "/") window.history.pushState({}, "", target);
        }
      } catch { /* ignore malformed */ }
    });
  } catch { /* plugin optional */ }
}
